/* eslint-disable promise/catch-or-return */
/* eslint-disable promise/always-return */
import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import {injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';

import {Icon} from '@stubhub/bamboo';
import {isDefined} from '@stubhub/general-utils';
import {get} from '@stubhub/rest-method';

import FEATURE_FLAGS from '../../utils/featureFlags';
import {getUserGUID} from '../../utils/utility';

import messages from './messages';
import NavItem from './navigation_item';

import './index.scss';

class Navigation extends React.Component {
  static contextTypes = {
    globalRegistry: PropTypes.object,
  };

  static propTypes = {
    populateActiveNavItem: PropTypes.func,
  };

  constructor(props, context) {
    super(props, context);

    const {
      intl,
      match: {path},
    } = props;
    const {globalRegistry} = context;
    const showPromoCode = globalRegistry.getFeatureValue(FEATURE_FLAGS.common.promocode);
    const showSellerPaymentsConfig = globalRegistry.getFeatureValue(FEATURE_FLAGS.submenus.paymentSellerConfig);
    const hideFavorites = globalRegistry.getFeatureValue(FEATURE_FLAGS.mya.menu.hideFavorites);
    const showBuyerPaymentsConfig = globalRegistry.getFeatureValue(FEATURE_FLAGS.submenus.paymentBuyerConfig);
    const paymentsLink = showBuyerPaymentsConfig ? `${path}/payments/config/buyer` : `${path}/payments`;

    this.navItems = [
      {href: `${path}/profile`, label: intl.formatMessage(messages.profile), key: 'profile'},
      {href: `${path}/orders`, label: intl.formatMessage(messages.orders), key: 'orders'},
      {href: `${path}/listings`, label: intl.formatMessage(messages.listings), key: 'listings'},
      {href: `${path}/sales`, label: intl.formatMessage(messages.sales), key: 'sales'},
      {href: paymentsLink, label: intl.formatMessage(messages.payments), key: 'payments', subItems: []},
      // {href: `${path}/activity`, label: intl.formatMessage(messages.activity), key: 'activity'},
      // {href: `${path}/friends`, label: intl.formatMessage(messages.friends), key: 'friends'},
      ...(hideFavorites
        ? []
        : [{href: `${path}/favorites`, label: intl.formatMessage(messages.favorites), key: 'favorites'}]),
      {
        href: `${path}/rewards`,
        label: intl.formatMessage(showPromoCode ? messages.promoCodes : messages.giftCodes),
        key: 'rewards',
      },
      {href: `${path}/settings`, label: intl.formatMessage(messages.settings), key: 'settings', active: true},
    ];

    const paymentsNavItemSubItems = this.navItems.find((navItem) => navItem.key === 'payments').subItems;
    showBuyerPaymentsConfig &&
      paymentsNavItemSubItems.push({
        href: `${path}/payments/config/buyer`,
        label: intl.formatMessage(messages.buyerPayments),
        key: 'paymentsBuyer',
      });
    showSellerPaymentsConfig &&
      paymentsNavItemSubItems.push({
        href: `${path}/payments/config/seller`,
        label: intl.formatMessage(messages.sellerPayments),
        key: 'paymentsSeller',
      });
    if (paymentsNavItemSubItems.length) {
      const method = showBuyerPaymentsConfig ? 'push' : 'unshift';
      paymentsNavItemSubItems[method]({
        href: `${path}/payments`,
        label: intl.formatMessage(messages.payoutHistory),
        key: 'paymentsHistory',
      });
    }

    const currentItem =
      this.flattedNavItems().find((item) => this.props.location.pathname === item.href) ||
      this.flattedNavItems().find((item) => this.props.location.pathname.includes(item.href));

    this.state = {
      navExpanded: false,
      tinAlert: false,
      activeNavItemLabel: !currentItem ? '' : currentItem.label,
      activeMobileMenuItemLabel: !currentItem
        ? ''
        : currentItem.parent
        ? `${currentItem.parent} > ${currentItem.label}`
        : currentItem.label,
    };
  }

  updateNavItemAndMenu = (currentItem) => {
    this.setState({
      activeNavItemLabel: currentItem.label,
      activeMobileMenuItemLabel: currentItem.parent
        ? `${currentItem.parent} > ${currentItem.label}`
        : currentItem.label,
    });
  };

  flattedNavItems = () =>
    this.navItems.reduce((acc, item) => {
      item?.subItems?.forEach((subItem) => acc.push({...subItem, parent: item.label}));
      acc.push(item);

      return acc;
    }, []);

  updateCurrentItem = (path) => {
    const currentItem = this.flattedNavItems().find((item) => item.href === path);
    if (currentItem) {
      this.updateNavItemAndMenu(currentItem);
      this.props.populateActiveNavItem && this.props.populateActiveNavItem(currentItem.label);
      this.setState({
        navExpanded: !this.state.navExpanded,
      });
    }
  };

  toggleNavExpasion = () => {
    this.setState({
      navExpanded: !this.state.navExpanded,
    });
    this.updateCurrentItem(this.props.location.pathname);
  };

  updateTinStatus = (/* istanbul ignore next */ tinStatus = {}) => {
    this.setState({
      tinAlert: !!tinStatus.alert,
    });
  };

  componentDidMount() {
    this.props.populateActiveNavItem && this.props.populateActiveNavItem(this.state.activeNavItemLabel);
    const userGUID = getUserGUID();

    get({
      host: process.env.REACT_APP_API_HOST,
      query: {external: true},
      json: true,
      path: `/bfm/accountmanagement/taxid/v1/seller/${userGUID}`,
    })
      .then((res) => {
        this.updateTinStatus(res);
      })
      .catch((e) => {});
  }

  render() {
    const {navExpanded, activeNavItemLabel, activeMobileMenuItemLabel} = this.state;

    if (typeof document !== 'undefined' && activeNavItemLabel && isDefined(document)) {
      document.title = activeNavItemLabel;
    }

    const menus = this.navItems.map(({href, label, key, subItems}) => {
      const hasAlert = href.indexOf('/my/settings') >= 0 && this.state.tinAlert;

      return (
        <NavItem
          key={key}
          href={href}
          label={label}
          subItems={subItems}
          hasAlert={hasAlert}
          onClick={(path) => this.updateCurrentItem(path)}
        />
      );
    });

    return (
      <>
        <div className="Nav_Header" onClick={this.toggleNavExpasion}>
          <div className="Nav_Header__text">{activeMobileMenuItemLabel}</div>
          <Icon name="ArrowDown" size="sm" className={cs('Nav_Header__menuArrow', {active: navExpanded})} />
        </div>
        <ul className={cs('Nav_Container', {expand: navExpanded})}>{menus}</ul>
      </>
    );
  }
}
const NavigationWithRouter = withRouter(Navigation);
export default injectIntl(NavigationWithRouter);
